export default __webpack_public_path__ + "static/media/2.95ac0c89.PNG";